import * as React from "react";
import PropTypes from 'prop-types';

const SvgWhitePlayIcon = props => {
  if (props.id !== "_svgwhiteplayicon") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 25 28" fill="none" {...props}><path d="M3.51 1.562a1 1 0 00-1.51.86v23.156a1 1 0 001.51.86L23.048 14.86a.999.999 0 000-1.72L3.51 1.562z" fill="#fff" stroke="#fff" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

SvgWhitePlayIcon.displayName = "_svgwhiteplayicon";
SvgWhitePlayIcon.propTypes = {
  id: PropTypes.string
};
SvgWhitePlayIcon.defaultProps = {
  id: ''
};
export default SvgWhitePlayIcon;